import axios from '../axios';

const chartOfAccountsApi = {
  getAll: (params) => axios.get('/ChartOfAccounts', { params }),
  getTree: () => axios.get('/ChartOfAccounts/tree'),
  getById: (id) => axios.get(`/ChartOfAccounts/${id}`),
  getByLevel: (level) => axios.get(`/ChartOfAccounts/level/${level}`),
  getPostable: () => axios.get('/ChartOfAccounts/postable'),
  create: (data) => axios.post('/ChartOfAccounts', data),
  getNextCode: (parentId) => axios.get(`/ChartOfAccounts/next-code/${parentId}`),
  update: (id, data) => axios.put(`/ChartOfAccounts/${id}`, data),
  delete: (id) => axios.delete(`/ChartOfAccounts/${id}`),
  seedStandard: () => axios.post('/ChartOfAccounts/seed-standard'),
};

export default chartOfAccountsApi;
